import { ProgramDate, ProgramDateRef } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateProgramDate: (
  fetchContext: FetchContext,
  programId: number,
  programDate: ProgramDate,
  accessToken?: string
) => Promise<ProgramDateRef> = (fetchContext: FetchContext, programId: number, programDate: ProgramDate, accessToken?: string) => fetch(
  `${fetchContext.baseUrl}/api/staff/programs/${programId}/program-dates/${programDate.programDateId}`,
  {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    },
    body: JSON.stringify(programDate),
  }).then(response => responseErrorHandler<ProgramDateRef>(fetchContext.errorStore, response, 'update program date'));
